import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { get } from 'lodash';
export default {
  name: 'DeviceTemplatesUnsyncedChanges',
  props: {
    template: {
      type: Object,
      required: true
    },
    hasUnsavedChanges: {
      type: Boolean,
      required: true
    },
    linkedDevicesTotalCount: {
      type: Number,
      required: true
    },
    unsyncedChanges: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      allDevicesSynced: false,
      tableLoading: false,
      expanded: [],
      syncDialogOpen: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.modification'),
          value: 'modification'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.valueBeforeSync'),
          value: 'valueBeforeSync'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.valueAfterSync'),
          value: 'valueAfterSync'
        }]
      };
    },
    promptButtons: function promptButtons() {
      var buttons = [{
        text: this.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }];

      if (this.hasUnsavedChanges) {
        buttons.push({
          text: this.$i18n_t('Common.saveAndSynchronise'),
          color: this.color,
          emit: 'saveAndSynchronise'
        });
      } else {
        buttons.push({
          text: this.$i18n_t('Common.synchronise'),
          color: this.color,
          emit: 'saveAndSynchronise'
        });
      }

      return buttons;
    },
    syncDisabled: function syncDisabled() {
      return this.linkedDevicesTotalCount === 0 || get(this.template, 'deviceSyncStatus.isRunning') || this.unsyncedChanges.length === 0;
    }
  }),
  methods: {
    saveAndSynchronise: function () {
      var _saveAndSynchronise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return ApiService.deviceTemplatePublishAndSync(this.template);

              case 3:
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.syncStarted'), 'success');
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.syncError'), 'error');

              case 9:
                _context.next = 11;
                return ApiService.deviceTemplateGetByIdDraft(this.template.id);

              case 11:
                this.template = _context.sent;
                this.$emit('save-and-synchronise', this.template);
                this.syncDialogOpen = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function saveAndSynchronise() {
        return _saveAndSynchronise.apply(this, arguments);
      }

      return saveAndSynchronise;
    }()
  }
};